import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-option-tree-subdivision',
  templateUrl: './option-tree-subdivision.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class OptionTreeSubdivisionComponent {
  @Input() public subdivisions: any;
  // { required: true }
}
